const getFileByUrl = async (url: string) => {
  const response = await fetch(url);
  const filename = url.split('/').pop() ?? 'photo.jpeg';

  return new File([await response.blob()], filename);
}

export default getFileByUrl;